<template>
  <div class="detail-field">
    <div class="detail-field-label">{{ label }}</div>
    <div class="detail-field-value">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: '' }
})
</script>

<style scoped>
.detail-field {
  padding: 0.5rem 0;
}

.detail-field + .detail-field {
  border-top: 1px solid var(--tblr-border-color);
}

.detail-field-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(var(--tblr-body-color-rgb), 0.6);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0.125rem;
}

.detail-field-value {
  font-size: 0.875rem;
  color: var(--tblr-body-color);
}
</style>
